<template lang="html">
  <layout>
    <v-container grid-list-xl>
      <v-layout row wrap justify-space-between>
        <v-flex xs12 >
          <span class="headline">Your Reward Progression</span>
          <v-stepper alt-labels>
            <v-stepper-header>
              <v-stepper-step step="1" :complete="approvedJobs.length > 0" color="green">Rebate 1 ($250)</v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step step="2" :complete="approvedJobs.length > 1" color="green">Rebate 2 ($250)</v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step step="3" :complete="approvedJobs.length > 2" color="green">Accruing Co-Op</v-stepper-step>
            </v-stepper-header>
          </v-stepper>
        </v-flex>
        <v-toolbar flat dense light color="rgba(0,0,0,0)">
          <v-toolbar-title>
            <span class="headline">My Jobs</span>
            </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn color="primary" @click="dialog = true, edit = false">New Job</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-flex >
          <v-card
          class="elevation-1">
            <v-data-table
              :headers="headers"
              :items="jobs"
              :search="search"
              :pagination.sync="pagination"
              class="elevation-0"
              :loading="loading"
              >
              <template v-slot:items="props">
                <td>{{ props.item.name }}</td>
                <td>
                  <v-chip
                    v-if="props.item.approval_status"
                    :color="getColor(props.item.approval_status)"
                    dark>
                    {{ props.item.approval_status.toUpperCase() }}
                  </v-chip>
                </td>
                <td>
                  <v-btn flat icon color="primary" @click="editJob(props.item.job_id)" v-if="props.item.approval_status.toUpperCase() != 'Approved'.toUpperCase() && props.item.approval_status.toUpperCase() != 'Denied'.toUpperCase()">
                    <v-icon>fas fa-edit</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <NewJobForm :edit="edit" :editJobId.sync="editJobId" v-if="dialog" :dialog.sync="dialog" />
  </layout>
</template>

<script>
import Layout from '@/shared/Layout'
import NewJobForm from './_form'
import _ from 'lodash'

export default {
  data () {
    return {
      dialog: false,
      search: '',
      editJobId: '',
      edit: false,
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: 'approval_status'
      },
      headers: [
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Status',
          value: 'approval_status'
        },
        {
          text: 'Actions'
        }
      ],
      jobs: []
    }
  },
  computed: {
    approvedJobs () {
      return _.filter(this.jobs, ['approval_status', 'APPROVED'])
    }
  },
  methods: {
    editJob (job) {
      this.dialog = true
      this.editJobId = job
      this.edit = true
    },
    getColor (status) {
      if (status === 'APPROVED') return 'green'
      else if (status.toUpperCase() === 'PENDING') return 'orange'
      else if (status === 'Draft') return 'grey'
      else return 'red'
    },
    getJobs () {
      this.$http({
        method: 'get',
        url: '/remodeler/jobs'
      }).then((response) => {
        this.jobs = response.data
        this.loading = false
      })
    }
  },
  watch: {
    dialog () {
      this.getJobs()
    }
  },
  components: {
    Layout,
    NewJobForm
  },
  mounted () {
    this.getJobs()
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Jobs/Index.vue